import React, { useState, useEffect } from "react";
import "./HospitalityCategoriesPage.scss"
import { useSelector } from "react-redux";
import LayoutTemplate from "../../components/layouts/LayoutTemplate";
import { LOCAL_STORAGE_ITEMS_NAMES } from "../../../../../utilities/helper";
import Footer from "../../components/Footer/Footer";
import CustomDropdown from "../../components/CustomDropdown/CustomDropdown";
import grid from "../../assets/grid.svg"
import list from "../../assets/list.svg"
import CheckBoxContainer from "./filterComponents/CheckBoxContainer";
import RatingRadioButton from "./filterComponents/RatingRadioButton";
import RangeContainer from "./filterComponents/RangeContainer";
import Pagination from "../../components/Pagination/Pagination";
import MenuFooter from "../../components/Footer/MenuFooter/MenuFooter";
import { getAllData } from "../../../../../../../redux/resturantWidgetSlice";



const HospitalityCategoriesPage = () => {
    const [data, setData] = useState([])
    useEffect(() => {
        getAllData().then((result) => {
            setData(result?.data?.Items);
        });
    }, []);
    const [menuData, setMenuData] = useState(data.slice(0, 12))
    const [selectedLayout, setSelectedLayout] = useState("layout3")
    const [currentPage, setCurrentPage] = useState(1);
    const [selected, setSelected] = useState(sortList[0]);

    const totalItems = data.length
    const itemsPerPage = 12
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const filters = [
        {
            Title: "Price Range",
            Type: "range",
            Range: {
                Min: 0,
                Max: 2500
            },
            Rating: [],
            Items: []

        },
        {
            Title: "Dietary Preferences",
            Type: "checkbox",
            Range: {
                From: "",
                T0: ""
            },
            Rating: [],
            Items: [{
                Label: "Vegetarian",
                value: "vegetarian",
                count: 12
            }, {
                Label: "Vegan",
                value: "vegan",
                count: 5
            },
            {
                Label: "Gluten-Free",
                value: "glutenFree",
                count: 8
            },
            {
                Label: "Dairy-Free",
                value: "dairyFree",
                count: 3
            }

            ]

        },
        {
            Title: "Topings",
            Type: "checkbox",
            Range: {
                From: "",
                T0: ""
            },
            Rating: [],
            Items: [{
                Label: "Pepperoni",
                value: "pepperoni",
                count: 18
            }, {
                Label: "Mushrooms",
                value: "mushrooms",
                count: 14
            },
            {
                Label: "Bell Peppers",
                value: "bellPeppers",
                count: 11
            },
            {
                Label: "Onions",
                value: "onions",
                count: 10
            }
                ,
            {
                Label: "Sausage",
                value: "sausage",
                count: 9
            }
            ]

        },
        {
            Title: "Rating",
            Type: "radio-rating",
            Range: {
                From: "",
                T0: ""
            },
            Rating: [{
                Star: "5",
                Count: 8
            },
            {
                Star: "4",
                Count: 16
            }, {
                Star: "3",
                Count: 24
            }],
            Items: []


        }
    ]
    const sortList = [
        { value: "popular", label: "Popular" },
        { value: "newest", label: "Newest" },
        { value: "lowest", label: "Lowest Price" },
        { value: "highest", label: "Highest Price" }
    ]
    const getCheckbox = (items) => {
        return (
            items.map((item) => {
                return <CheckBoxContainer item={item} />

            })
        )
    }
    const getRadioRating = (items) => {
        return <RatingRadioButton items={items} />
    }
    const getRange = (range) => {
        return <RangeContainer rangeValue={range} />
    }
    const getTypesContent = (item) => {
        switch (item.Type) {
            case "checkbox":
                return getCheckbox(item.Items)
            case "radio-rating":
                return getRadioRating(item.Rating)
            case "range":
                return getRange(item.Range)

            default:
                return getCheckbox(item.Items)


        }
    }

    return (
        <>
            <div className="HospitalityCategoriesPage">
                <div className="HospitalityCategoriesPage-header">
                    <div className="Header-text">
                        Menu
                        <div className="pagination-count">Showing {totalItems} products</div>
                    </div>
                    <div className="header-right-cat">
                        <CustomDropdown items={sortList} selected={selected} setSelected={setSelected} />
                        <div className="layout-picker">
                            <div className={`left-grid ${selectedLayout === "layout3" ? "selected" : ""}`} onClick={() => {
                                setSelectedLayout("layout3")
                            }}>
                                <img alt="" src={grid} />
                            </div>
                            <div className={`right-lst ${selectedLayout === "layout1" ? "selected" : ""}`}
                                onClick={() => {
                                    setSelectedLayout("layout1")
                                }}>
                                <img alt="" src={list} />

                            </div>
                        </div>
                    </div>
                </div>
                <div className="innerCategories">
                    <div className="filter-layout">
                        <div className="filter-header-containare">
                            <div className="fltr-header">Filters</div>
                            <div className="clr-header">Clear All</div>
                        </div>
                        <div className="filter-containet">
                            {filters.map((filter, key) => {
                                return (
                                    <div className="filter-cont" key={key}>
                                        <div className="filter-title ">{filter.Title}</div>
                                        {getTypesContent(filter)}
                                    </div>
                                )
                            })}
                        </div>
                        <div className="flt-btn-cont">
                            Apply Filters
                        </div>

                    </div>
                    <div className="items-layout">
                        <LayoutTemplate layout={selectedLayout} items={
                            menuData || []
                        }
                            showHeader={false} />


                        <div className="pagination-container">
                            <div className="pagination-count">Showing {(12 * currentPage) - 11} - {12 * currentPage} of {totalItems} products</div>
                            <Pagination
                                totalItems={totalItems}
                                itemsPerPage={itemsPerPage}
                                currentPage={currentPage}
                                onPageChange={(e) => {
                                    setCurrentPage(e)
                                    setMenuData(data.slice(((12 * e) - 12), ((12 * e) + 12)))
                                }}
                            />
                        </div>

                    </div>
                </div>

            </div>
            <MenuFooter />
        </>

    )
}
export default HospitalityCategoriesPage